import { DefaultService as AccountsSDK } from '@atbay/account-service-node-sdk'
import { createClient } from '@core/base/http-client'

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const AccountsClient = createClient(AccountsSDK)
